/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

import Home from "./views/Home.vue";
import SavedItems from "./views/SavedItems.vue";
import groupVideos from "./views/groupVideosPage.vue";
import VideoPage from "./views/VideoPage.vue";
import TeacherPage from "./views/TeacherPage.vue";
import CurrentPage from "./views/CurrentPage.vue";
import VideoList from "./views/VideoList.vue";
import CurrentVideoList from "./views/CurrentVideoList.vue";
import Discover from "./views/Discover.vue";
import HistoryPage from "./views/HistoryPage.vue";
import MyTeachersPage from "./views/MyTeachersPage.vue";
import AccountPage from "./views/AccountPage.vue";
import ProfilePage from "./views/ProfilePage.vue";
import Preferences from "./views/Preferences.vue";
import SeriesPage from "./views/SeriesPage.vue";
import Cancel from "./views/Cancel.vue";
import Feedback from "./views/Feedback.vue";
import Renew from "./views/Renew.vue";
import NotFound from "./views/NotFound.vue";
import VideoCollections from "./views/videoCollections.vue";
import Results from "./views/SearchResults.vue";
import CreateEditPlaylist from "./views/createEditPlaylist.vue";
import SeriesCategories from "./views/seriesCategories.vue";
import SeriesCategoryPage from "./views/seriesCategoryPage.vue";

Vue.use(Router);

export default new Router({
  // mode: 'history',
  // scrollBehavior: (to, from, savedPosition) => {
  //   if (savedPosition) {
  //     // savedPosition is only available for popstate navigations.
  //     return savedPosition
  //   } else {
  //     const position = {}
  //     if (to.hash) {
  //       position.selector = to.hash
  //     }
  //   }
  // },
  base: "/mypage/",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/allseries",
      name: "allseries",
      component: SeriesCategories
    },
    {
      path: "/seriescategory/:catid",
      name: "seriesCategory",
      component: SeriesCategoryPage
    },
    {
      path: "/saveditems",
      name: "savedItems",
      component: SavedItems
    },
    {
      path: '/playlists',
      name: 'playlists',
      component: CreateEditPlaylist
    },
    {
      path: "/myteachers",
      name: "myteachers",
      component: MyTeachersPage
    },
    {
      path: "/teachers",
      name: "teachers",
      component: MyTeachersPage
    },
    {
      path: "/series",
      name: "series",
      component: groupVideos
    },
    {
      path: "/myseries",
      name: "myseries",
      component: groupVideos
    },

    {
      path: "/series/:sid",
      name: "videoSeries",
      component: SeriesPage
    },
    {
      path: "/video/:vid",
      name: "video",
      component: VideoPage
    },
    {
      path: "/teacher/:tid",
      name: "teacherPage",
      component: TeacherPage
    },
    {
      path: "/style/:cid",
      name: "currentPage",
      component: CurrentPage
    },
    {
      path: "/style/:cid/videos",
      name: "currentVideos",
      component: CurrentVideoList
    },
    {
      path: "/videos",
      name: "videolist",
      component: VideoList
    },
    {
      path: "/discover",
      name: "discover",
      component: Discover
    },
    {
      path: "/collections",
      name: "collections",
      component: VideoCollections
    },
    {
      path: "/history",
      name: "history",
      component: HistoryPage
    },
    {
      path: "/account",
      name: "account",
      component: AccountPage
    },
    {
      path: "/profile",
      name: "profile",
      component: ProfilePage
    },
    {
      path: "/preferences",
      name: "preferences",
      component: Preferences
    },
    {
      path: "/preferences/new",
      name: "newuser",
      component: Preferences
    },
    {
      path: "/cancel",
      name: "cancel",
      component: Cancel
    },
    {
      path: "/feedback",
      name: "feedback",
      component: Feedback
    },

    {
      path: "/renew",
      name: "renew",
      component: Renew
    },
    {
      path: "/results",
      name: "results",
      component: Results
    },
    {
      path: "/404",
      name: "404",
      component: NotFound
    },
    {
      path: "*",
      redirect: "/404"
    }
  ]
});
